// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';
import LocationSchema from './location-schema';

const schema = {
  $id: '/tdg-company-update-schema',
  type: 'object',
  required: ['id', 'creatorId', 'companyName', 'professionIds', 'companyContactSalutation', 'companyContactFirstName', 'companyContactLastName', 'companyContactPhoneNumber', 'companyContactEmail', 'companyStreet', 'companyZIP', 'companyCity', 'companyLocation', 'acceptConditions'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    companyName: {
      type: 'string',
      minLength: 1,
    },
    externalId: {
      type: 'string',
      format: 'uuid',
    },
    logoDocumentId: {
      type: 'integer',
      nullable: true,
    },
    description: {
      type: 'string',
      nullable: true,
    },
    website: {
      type: 'string',
      nullable: true,
    },
    employeesCount: {
      type: 'integer',
      nullable: true,
    },
    apprenticesCount: {
      type: 'integer',
      nullable: true,
    },
    apprenticeShipsCount: {
      type: 'integer',
      nullable: true,
    },
    professionIds: {
      type: 'array',
      items: {
        type: 'integer',
      },
    },
    companyContactSalutation: {
      enum: [
        0,
        1,
        2,
      ],
    },
    companyContactFirstName: {
      type: 'string',
      minLength: 1,
    },
    companyContactLastName: {
      type: 'string',
      minLength: 1,
    },
    companyContactPhoneNumber: {
      type: 'string',
      minLength: 1,
    },
    companyContactEmail: {
      type: 'string',
      minLength: 1,
    },
    companyStreet: {
      type: 'string',
      minLength: 1,
    },
    companyHouseNumber: {
      type: 'string',
      nullable: true,
    },
    companyZIP: {
      type: 'string',
      minLength: 1,
    },
    companyCity: {
      type: 'string',
      minLength: 1,
    },
    companyLocation: {
      ...LocationSchema,
    },
    acceptConditions: {
      type: 'boolean',
    },
    companyUserId: {
      type: 'integer',
      nullable: true,
    },
    logoDocumentExternalId: {
      type: 'string',
      nullable: true,
    },
    organisationExternalId: {
      type: 'string',
      format: 'uuid',
      nullable: true,
    },
    userName: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
